/* eslint-disable */
import {
    Component,
    ViewEncapsulation,
    Inject,
    OnInit,
    OnDestroy,
    ChangeDetectorRef,
    ViewChild,
    ViewContainerRef,
    AfterViewInit,
    ComponentFactoryResolver,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Field } from "../vforms-model";
import { cloneDeep } from "lodash-es";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BaseFieldEditorComponent } from "../base-field-editor.component";

export interface FieldEditorDialogData {
    field: Field;
}

@Component({
    selector: "field-editor-dialog",
    templateUrl: "field-editor.component.html",
    styles: [
        /* language=SCSS */ `
            .field-editor-dialog {
                .mat-dialog-container {
                    padding: 0 !important;
                    margin: 0 !important;
                    width: 80vw !important;
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class FieldEditorComponent implements OnInit, OnDestroy, AfterViewInit {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    form: FormGroup;

    field: Field;

    editableField: Field;

    fieldValid: boolean;

    @ViewChild("fieldEditorContent", { read: ViewContainerRef }) fieldEditorContent;

    constructor(
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _changeDetector: ChangeDetectorRef,
        private _formBuilder: FormBuilder,
        public matDialogRef: MatDialogRef<FieldEditorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FieldEditorDialogData
    ) {
        this.matDialogRef.addPanelClass("field-editor-dialog");
        this.field = this.data.field;
        this.editableField = cloneDeep(this.field);
        this.form = this._formBuilder.group({
            label: [this.editableField.label, [Validators.required]],
            description: [this.editableField.description],
            required: [this.editableField.required],
        });
    }

    ngOnInit(): void {
        this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            this.editableField.update(value);
            this._changeDetector.detectChanges();
        });
    }

    ngAfterViewInit() {
        const factory = this._componentFactoryResolver.resolveComponentFactory(this.editableField.type.editorComponent);
        const componentRef = this.fieldEditorContent.createComponent(factory);
        const instance = componentRef.instance as BaseFieldEditorComponent;
        instance.field = this.editableField;
        instance.onValid.pipe(takeUntil(this._unsubscribeAll)).subscribe((valid) => {
            this.fieldValid = valid;
            this._changeDetector.detectChanges();
        });
        this._changeDetector.detectChanges();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    save() {
        this.field.update(this.editableField);
        this.matDialogRef.close(this.field);
    }
}
